import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=74e5cf76&"
import script from "./feature.js?vue&type=script&lang=js&"
export * from "./feature.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports